<script setup>
import { onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { usePolicy } from 'dashboard/composables/usePolicy';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const store = useStore();
const route = useRoute();
const { uiSettings, updateUISettings } = useUISettings();
const { isFeatureFlagEnabled } = usePolicy();

// Deep links / hard refresh skip AssistantsIndexPage, so load the list here.
const ensureAssistantsLoaded = () => {
  if (!isFeatureFlagEnabled(FEATURE_FLAGS.CAPTAIN)) return undefined;
  const { fetchingList } = store.getters['captainAssistants/getUIFlags'];
  const records = store.getters['captainAssistants/getRecords'];
  if (fetchingList || records.length > 0) return undefined;
  return store.dispatch('captainAssistants/get');
};

onMounted(() => {
  ensureAssistantsLoaded();
});

watch(
  () => route.params.assistantId,
  newAssistantId => {
    if (
      newAssistantId &&
      newAssistantId !== String(uiSettings.value.last_active_assistant_id)
    ) {
      updateUISettings({
        last_active_assistant_id: Number(newAssistantId),
      });
    }
  }
);
</script>

<template>
  <div class="flex w-full h-full min-h-0">
    <section class="flex flex-1 h-full px-0 overflow-hidden bg-n-surface-1">
      <router-view />
    </section>
  </div>
</template>
